import React from 'react';
import {withRouter} from 'react-router';
import moment from 'moment';
import {
  Row,
  Col,
  Grid,
  Panel,
  PanelBody,
  PanelHeader,
  PanelContainer,
} from '@sketchpixy/rubix';

import {getHistory} from '../api/api';
import TimelineView from '../common/TimelineView';
import {routeUrl} from './routeUrl';

@withRouter
export default class Dashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loginHistory: [],
      assetUploadHistory: [],
      copyHistory: [],
    };
  }

  componentDidMount = () => {
    let accessToken = localStorage.getItem('access_token');

    if (this.props.location.query.access_token) {
      accessToken = this.props.location.query.access_token;
      localStorage.setItem('access_token', accessToken);
    }

    getHistory((err, result) => {
      if (err) {
        console.error('get history err!');
        this.props.router.push(routeUrl.login);
      } else {
        this.setState({assetUploadHistory: result.dashboard});
      }
    });
  };

  render() {
    return (
        <div className="dashboard">
          <Row>
            <Col sm={11} smCollapseRight>
              <PanelContainer controls={false} bordered>
                <Panel>
                  <PanelHeader className="bg-green">
                    <Grid>
                      <Row>
                        <Col xs={12} className="fg-white">
                          <h4>Logs</h4>
                        </Col>
                      </Row>
                    </Grid>
                  </PanelHeader>
                  <PanelBody>
                    {
                      this.state.assetUploadHistory.length > 0 ? (
                          this.state.assetUploadHistory.map((obj, index) => {
                            let time = moment.utc(obj.createdTime).format('llll');
                            let des = (
                                <div>
                                  <p>
                                    User name : {obj.adminUserEmail}
                                  </p>
                                  <p>
                                    Detail : {obj.adminActivityLogDetail}
                                  </p>
                                </div>
                            );
                            return (<TimelineView title={time} des={des} key={index} color="green" />);
                          })
                      ) : null
                    }
                  </PanelBody>
                </Panel>
              </PanelContainer>
            </Col>
          </Row>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Dashboard.js